import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gl-cookie-banner-modal"
}
const _hoisted_2 = {
  class: "gl-cookie-banner-modal__dialog",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Cookie settings"
}
const _hoisted_3 = { class: "gl-cookie-banner__text" }
const _hoisted_4 = { class: "gl-cookie-banner__text-paragraph" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "gl-cookie-banner__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "gl-cookie-banner-modal__overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "gl-cookie-banner__title" }, "настройки файлов cookie", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "gl-cookie-banner__text-paragraph" }, " Мы используем файлы cookie и аналогичные технологии для обеспечения корректной работы Портала GS, повышения производительности платформы, анализа статистики использования и улучшения пользовательского опыта. ", -1)),
            _createElementVNode("p", _hoisted_4, [
              _cache[2] || (_cache[2] = _createTextVNode(" Нажимая «", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Принять", -1)),
              _cache[4] || (_cache[4] = _createTextVNode("», вы даёте согласие на использование файлов cookie и аналогичных технологий в соответствии с нашей ", -1)),
              _createElementVNode("a", {
                href: _ctx.privacyPolicyUrl,
                target: "_blank",
                rel: "noopener noreferrer"
              }, "Политикой конфиденциальности.", 8, _hoisted_5),
              _cache[5] || (_cache[5] = _createTextVNode(" Вы можете в любое время управлять своими предпочтениями через настройки браузера или устройства. ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "gl-cookie-banner__btn-reject",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reject && _ctx.reject(...args)))
            }, "Отклонить"),
            _createElementVNode("button", {
              type: "button",
              class: "gl-cookie-banner__btn-accept",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
            }, "Принять")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}